module.exports = "/static/assets/5d3949c26ee9df35dfc3699d356edd5b.png";